export default __webpack_public_path__ + "static/media/logopremium-negativa.2d1d7499.svg";